import { render, staticRenderFns } from "./PortalTopBar.vue?vue&type=template&id=1817705b&scoped=true"
import script from "./PortalTopBar.vue?vue&type=script&lang=js"
export * from "./PortalTopBar.vue?vue&type=script&lang=js"
import style0 from "./PortalTopBar.vue?vue&type=style&index=0&id=1817705b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1817705b",
  null
  
)

export default component.exports